import React, {useEffect, useRef, useState} from "react";
import { db } from "../../firebase";
import { collection, onSnapshot } from "firebase/firestore";
import moment from "moment-timezone";


const FloatingMapCard = ({ text, directionsEnabled, directions, onCallinsChange, isFullscreenMapVisible, callId, agency }) => {
  const defaultImgUrl = "https://firebasestorage.googleapis.com/v0/b/ladderemsrn.appspot.com/o/photos%2Favatar.png?alt=media&token=8e349a8b-01d2-4e6b-bc9c-fc23482d2230&_gl=1*elqacr*_ga*OTczNjc0NTc5LjE2OTYzNjk8e349a8b-01d2-4e6b-bc9c-fc23482d2230&_gl=1*elqacr*_ga*OTczNjc0NTc5LjE2OTYzNjk";
  
  const hasActiveCall = text && Object.keys(text).length > 0;
  const eventDetailsRef = useRef(null);
  const [scrollDirection, setScrollDirection] = useState('down');
  const [timestamps, setTimestamps] = useState([]);
  const [uniqueUnits, setUniqueUnits] = useState([]);
  const [statusColumns, setStatusColumns] = useState([]);
  const [unitsWithMultipleSets, setUnitsWithMultipleSets] = useState({});

  const tableHeaderStyle = {
    border: "1px solid rgba(255, 255, 255, 0.2)",
    padding: "8px",
    textAlign: "left",
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    fontSize: "11px",
    fontWeight: "bold",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  };
  
  const tableCellStyle = {
    border: "1px solid rgba(255, 255, 255, 0.1)",
    padding: "8px",
    fontSize: "12px",
  };

  // Define unit status mapping with display order
  const unitStatusMapping = {
    "Dispatched": { id: "Dispatched", label: "Dispatched", order: 1 },
    "2": { id: "Dispatched", label: "Dispatched", order: 1 },
    "Enroute": { id: "Enroute", label: "Enroute", order: 2 },
    "3": { id: "Enroute", label: "Enroute", order: 2 },
    "On Scene": { id: "On Scene", label: "On Scene", order: 3 },
    "4": { id: "On Scene", label: "On Scene", order: 3 },
    "Transporting": { id: "Transporting", label: "Transporting", order: 4 },
    "6": { id: "Transporting", label: "Transporting", order: 4 },
    "At Hospital": { id: "At Hospital", label: "At Hospital", order: 5 },
    "At Transport Destination": { id: "At Hospital", label: "At Hospital", order: 5 },
    "7": { id: "At Hospital", label: "At Hospital", order: 5 },
    "Returning": { id: "Returning", label: "Returning", order: 6 },
    "Back in Service": { id: "Returning", label: "Returning", order: 6 },
    "9": { id: "Returning", label: "Returning", order: 6 },
    "Available": { id: "Available", label: "Available", order: 7 },
    "1": { id: "Available", label: "Available", order: 7 },
  };




  let cardTextElement = null;
  let fresCommentsElement = null;
  let callinsElement = null;
  let directionsElement = null;

  if (text) {
    cardTextElement = (
      <div
        style={{
          color: "white",
          backgroundColor: "rgba(15, 23, 42, 0.98)",
          padding: "0",
          borderRadius: "0 0 8px 8px",
          textAlign: "left",
          maxHeight: "calc(100vh - 120px)",
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        {/* Call Type Section */}
        <div style={{
          padding: "12px 16px",
          backgroundColor: "rgba(239, 68, 68, 0.15)",
          borderLeft: "4px solid #ef4444",
          marginBottom: "2px",
        }}>
          <div style={{ 
            fontSize: "11px", 
            color: "rgba(255, 255, 255, 0.6)",
            textTransform: "uppercase",
            letterSpacing: "1px",
            marginBottom: "4px",
            fontWeight: "600",
          }}>Call Type</div>
          <div style={{ 
            fontSize: "15px",
            fontWeight: "700",
            color: "#ffffff",
            lineHeight: "1.3",
          }}>{text.CallType}</div>
        </div>

        {/* Dispatch Code Section */}
        {text.DispatchCode && (
          <div style={{
            padding: "12px 16px",
            backgroundColor: "rgba(234, 179, 8, 0.15)",
            borderLeft: "4px solid #eab308",
            marginBottom: "2px",
          }}>
            <div style={{ 
              fontSize: "11px", 
              color: "rgba(255, 255, 255, 0.6)",
              textTransform: "uppercase",
              letterSpacing: "1px",
              marginBottom: "4px",
              fontWeight: "600",
            }}>Dispatch Code</div>
            <div style={{ 
              fontSize: "17px",
              fontWeight: "700",
              color: "#fbbf24",
              letterSpacing: "1px",
              fontFamily: "monospace",
            }}>{text.DispatchCode}</div>
          </div>
        )}

        {/* Location Section */}
        <div style={{
          padding: "12px 16px",
          backgroundColor: "rgba(59, 130, 246, 0.1)",
          borderLeft: "4px solid #3b82f6",
          marginBottom: "2px",
        }}>
          <div style={{ 
            fontSize: "11px", 
            color: "rgba(255, 255, 255, 0.6)",
            textTransform: "uppercase",
            letterSpacing: "1px",
            marginBottom: "6px",
            fontWeight: "600",
          }}>📍 IncidentLocation</div>
          <div style={{ 
            fontSize: "17px",
            fontWeight: "600",
            color: "#ffffff",
            marginBottom: "4px",
            lineHeight: "1.4",
          }}>{text.Address}</div>
          {text.CrossStreet && (
            <div style={{ 
              fontSize: "14px",
              color: "rgba(255, 255, 255, 0.7)",
              fontStyle: "italic",
            }}>Cross: {text.CrossStreet}</div>
          )}
        </div>

        {/* FRES Comments Section */}
        {text.FRESComments && (
          <div style={{
            padding: "12px 16px",
            backgroundColor: "rgba(168, 85, 247, 0.1)",
            borderLeft: "4px solid #a855f7",
            marginBottom: "2px",
          }}>
            <div style={{ 
              fontSize: "11px", 
              color: "rgba(255, 255, 255, 0.6)",
              textTransform: "uppercase",
              letterSpacing: "1px",
              marginBottom: "6px",
              fontWeight: "600",
            }}>⚠️ REMARKS</div>
            <div style={{ 
              fontSize: "15px",
              fontWeight: "600",
              color: "#e9d5ff",
              lineHeight: "1.5",
            }}>{text.FRESComments}</div>
          </div>
        )}

        {/* Event Comments Section */}
        {text.EventComments && (
          <div style={{
            padding: "12px 16px",
            backgroundColor: "rgba(255, 255, 255, 0.05)",
            borderLeft: "4px solid rgba(255, 255, 255, 0.3)",
            marginBottom: "2px",
          }}>
            <div style={{ 
              fontSize: "11px", 
              color: "rgba(255, 255, 255, 0.6)",
              textTransform: "uppercase",
              letterSpacing: "1px",
              marginBottom: "6px",
              fontWeight: "600",
            }}>💬 Event Details</div>
            <div 
              ref={eventDetailsRef}
              style={{ 
                fontSize: "14px",
                color: "rgba(255, 255, 255, 0.85)",
                lineHeight: "1.6",
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
                maxHeight: "200px",
                overflowY: "auto",
                scrollBehavior: "smooth",
              }}>{text.EventComments}</div>
          </div>
        )}

        {/* Unit Status Section - Compact View */}
        {console.log('🎨 Rendering UI - uniqueUnits:', uniqueUnits, 'length:', uniqueUnits.length)}
        {uniqueUnits.length > 0 ? (
          <div style={{
            padding: "12px 16px",
            backgroundColor: "rgba(34, 197, 94, 0.1)",
            borderLeft: "4px solid #22c55e",
          }}>
            <div style={{ 
              fontSize: "11px", 
              color: "rgba(255, 255, 255, 0.6)",
              textTransform: "uppercase",
              letterSpacing: "1px",
              marginBottom: "8px",
              fontWeight: "600",
            }}>Units:</div>
            <div style={{ 
              maxHeight: "200px", 
              overflowY: "auto",
              display: "flex",
              flexDirection: "column",
              gap: "6px",
            }}>
              {uniqueUnits.map((unitId) => {
                // Get the latest status for this unit
                const getLatestStatus = (unitId) => {
                  const unitSet = unitsWithMultipleSets[unitId] || 1;
                  const unitTimestamps = timestamps.filter(ts => 
                    ts.name === unitId && ts.set === unitSet && ts.timestamp
                  );

                  if (unitTimestamps.length === 0) return null;

                  // Sort by timestamp to get the most recent
                  const sorted = unitTimestamps.sort((a, b) => {
                    const timeA = a.timestamp?.toDate ? a.timestamp.toDate() : new Date(a.timestamp);
                    const timeB = b.timestamp?.toDate ? b.timestamp.toDate() : new Date(b.timestamp);
                    return timeB.getTime() - timeA.getTime();
                  });

                  const latest = sorted[0];
                  const timestamp = latest.timestamp?.toDate 
                    ? latest.timestamp.toDate() 
                    : new Date(latest.timestamp);

                  return {
                    status: latest.signal,
                    time: moment(timestamp).format("HH:mm:ss")
                  };
                };

                const latestStatus = getLatestStatus(unitId);
                if (!latestStatus) return null;

                // Color mapping based on status
                const getStatusColor = (status) => {
                  const statusId = unitStatusMapping[status]?.id || status;
                  switch(statusId) {
                    case "Dispatched": return "#eab308"; // yellow
                    case "Enroute": return "#f97316"; // orange
                    case "On Scene": return "#10b981"; // green
                    case "Transporting": return "#8b5cf6"; // purple
                    case "At Hospital": return "#06b6d4"; // cyan
                    case "Returning": return "#10b981"; // green
                    case "Available": return "#6b7280"; // gray
                    default: return "#3b82f6"; // blue
                  }
                };

                const statusColor = getStatusColor(latestStatus.status);
                const statusLabel = unitStatusMapping[latestStatus.status]?.label || latestStatus.status;

                return (
                  <div key={unitId} style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "8px 10px",
                    backgroundColor: "rgba(0, 0, 0, 0.3)",
                    borderRadius: "4px",
                    borderLeft: `3px solid ${statusColor}`,
                  }}>
                    <div style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      flex: 1,
                    }}>
                      <span style={{
                        fontWeight: "700",
                        fontSize: "13px",
                        color: "#ffffff",
                        minWidth: "60px",
                      }}>{unitId}</span>
                      <span style={{
                        fontSize: "11px",
                        color: statusColor,
                        fontWeight: "600",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                      }}>{statusLabel}</span>
                    </div>
                    <span style={{
                      fontSize: "12px",
                      color: "rgba(255, 255, 255, 0.7)",
                      fontFamily: "monospace",
                      fontWeight: "600",
                    }}>{latestStatus.time}</span>
                  </div>
                );
              })}
            </div>
          </div>
        ) : null}
      </div>
    );

    
    if (text.Callins && text.Callins.length > 0) {
      callinsElement = (
        <div
          style={{
            position: "absolute",
            top: "0",
            right: "0",
            zIndex: 1000,
            background: "rgba(15, 23, 42, 0.98)",
            borderRadius: "0 0 0 8px",
            boxShadow: "-8px 0px 32px rgba(0, 0, 0, 0.6)",
            width: "380px",
            height: "100vh",
            overflowY: "auto",
            backdropFilter: "blur(10px)",
            border: "1px solid rgba(255, 255, 255, 0.1)",
            borderRight: "none",
            borderTop: "none",
          }}
        >
          {/* Header */}
          <div
            style={{
              background: "linear-gradient(135deg, #16a34a 0%, #15803d 100%)",
              color: "white",
              padding: "12px 16px",
              borderRadius: "0 0 0 8px",
              textAlign: "left",
              fontWeight: "700",
              position: "sticky",
              top: "0",
              zIndex: 1,
              fontSize: "14px",
              textTransform: "uppercase",
              letterSpacing: "1.5px",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.3)",
            }}
          >
            <span style={{ fontSize: "18px" }}>👥</span>
            <span>Personnel Responding</span>
          </div>
          {/* Table Content */}
          <div
            style={{
              padding: "10px",
              textAlign: "left",
            }}
          >
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                color: "white",
                fontSize: "12px", // Reduced text size
              }}
            >
              <thead>
                <tr>
                  <th style={tableHeaderStyle}>Name</th>
                  <th style={tableHeaderStyle}>Response</th>
                  <th style={tableHeaderStyle}>Called In</th>
                  <th style={tableHeaderStyle}>Qualifications</th>
                </tr>
              </thead>
              <tbody>
                {text.Callins.map((callin, index) => (
                  <tr key={index}>
                    <td style={tableCellStyle}>{callin.name}</td>
                    <td style={tableCellStyle}>{callin.response}</td>
                    <td style={tableCellStyle}>
                      {new Date(callin.timestamp.seconds * 1000).toLocaleTimeString()}
                    </td>
                    <td style={tableCellStyle}>
                      {callin.qualifications || ""}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      );
    }
  } else if (isFullscreenMapVisible) {
    cardTextElement = (
      <div
        style={{
          color: "white",
          backgroundColor: "rgba(15, 23, 42, 0.98)",
          padding: "20px",
          borderRadius: "0 0 8px 8px",
          textAlign: "center",
        }}
      >
        <div style={{
          fontSize: "14px",
          color: "rgba(255, 255, 255, 0.6)",
          textTransform: "uppercase",
          letterSpacing: "2px",
        }}>Stand By...</div>
        <div style={{
          fontSize: "16px",
          color: "#3b82f6",
          marginTop: "8px",
          fontWeight: "600",
        }}>Loading Call Data...</div>
      </div>
    );
  }
  if (directionsEnabled && directions) {
    directionsElement = (
      <div
        style={{
          position: "absolute",
          top: "2%",
          right: text?.Callins && text.Callins.length > 0 ? "390px" : "10px",
          zIndex: 1000,
          background: "rgba(0, 0, 0, 0.85)",
          borderRadius: "8px",
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.6), 0 0 0 1px rgba(255, 255, 255, 0.1)",
          maxWidth: "450px",
          maxHeight: "calc(100vh - 120px)",
          overflowY: "auto",
          backdropFilter: "blur(10px)",
          border: "1px solid rgba(255, 255, 255, 0.1)",
        }}
      >
        {/* Header */}
        <div
          style={{
            background: "linear-gradient(135deg, #2563eb 0%, #1e40af 100%)",
            color: "white",
            padding: "12px 16px",
            borderRadius: "8px 8px 0 0",
            textAlign: "left",
            fontWeight: "700",
            fontSize: "14px",
            textTransform: "uppercase",
            letterSpacing: "1.5px",
            position: "sticky",
            top: "0",
            zIndex: 1,
            display: "flex",
            alignItems: "center",
            gap: "8px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.3)",
          }}
        >
          <span style={{ fontSize: "18px" }}>🧭</span>
          <span>Navigation</span>
        </div>
        {/* Content */}
        <div
          style={{
            color: "white",
            backgroundColor: "rgba(15, 23, 42, 0.98)",
            padding: "16px",
            borderRadius: "0 0 8px 8px",
            textAlign: "left",
          }}
        >
          <ol style={{ paddingLeft: "20px" }}>
            {directions.routes[0].legs[0].steps.map((step, index) => (
              <li
                key={index}
                style={{ marginBottom: "10px", fontSize: "12px" }}
                dangerouslySetInnerHTML={{ __html: step.instructions }}
              />
            ))}
          </ol>
        </div>
      </div>
    );
  }
 
  // Fetch unit timestamps
  useEffect(() => {
    console.log('🔍 Unit timestamps useEffect triggered');
    console.log('agency:', agency);
    console.log('callId:', callId);
    console.log('text:', text);
    console.log('text?.id:', text?.id);
    
    if (!agency) {
      console.log('❌ Missing agency, skipping fetch');
      return;
    }
    
    if (!callId) {
      console.log('❌ Missing callId, skipping fetch');
      return;
    }

    try {
      const collectionPath = `${agency} Alarms/${callId}/PSAPTIMES`;
      console.log('📂 Fetching from collection path:', collectionPath);
      
      const SignalsRef = collection(db, collectionPath);
      
      // Try without orderBy first to see if we get any data
      const unsubscribe = onSnapshot(SignalsRef, (snapshot) => {
        console.log('📊 Snapshot received, doc count:', snapshot.docs.length);
        
        if (snapshot.docs.length === 0) {
          console.log('⚠️ No documents found in PSAPTIMES subcollection');
        }
        
        const timestampsData = snapshot.docs.map((doc) => {
          const data = doc.data();
          console.log('📄 Raw document data:', doc.id, data);
          return {
            id: doc.id,
            ...data,
          };
        });

        console.log('📋 Timestamps data:', timestampsData);

        const processedTimestamps = timestampsData.map(ts => {
          const processed = {
            id: ts.id,
            name: ts.UnitId || ts.name,
            signal: ts.UnitStatus || ts.signal,
            timestamp: ts.TimeStamp || ts.timestamp,
            UnitStatusTime: ts.UnitStatusTime,
            UnitDestination: ts.UnitDestination,
            set: ts.set || 1
          };
          console.log('✅ Processed timestamp:', processed);
          return processed;
        });

        console.log('🔄 All processed timestamps:', processedTimestamps);

        // Update the unitsWithMultipleSets state based on processed data
        const newUnitsWithMultipleSets = {};
        processedTimestamps.forEach(ts => {
          if (ts.set && ts.set > 1 && (!newUnitsWithMultipleSets[ts.name] || ts.set > newUnitsWithMultipleSets[ts.name])) {
            newUnitsWithMultipleSets[ts.name] = ts.set;
          }
        });

        setTimestamps(processedTimestamps);
        setUnitsWithMultipleSets(newUnitsWithMultipleSets);

        // Extract unique units and statuses
        const units = [...new Set(processedTimestamps.map(item => item.name).filter(Boolean))];
        console.log('🚒 Unique units:', units);
        setUniqueUnits(units);

        // Get all possible status columns from the mapping
        const uniqueStatuses = new Map();
        Object.values(unitStatusMapping).forEach(status => {
          uniqueStatuses.set(status.id, { id: status.id, order: status.order });
        });

        const statuses = Array.from(uniqueStatuses.values())
          .sort((a, b) => a.order - b.order)
          .map(status => status.id);

        console.log('📊 Status columns:', statuses);
        setStatusColumns(statuses);
      }, (error) => {
        console.error("❌ Error fetching unit timestamps:", error);
      });

      return () => {
        console.log('🧹 Cleaning up timestamps listener');
        unsubscribe();
      };
    } catch (error) {
      console.error("❌ Error setting up timestamps listener:", error);
    }
  }, [agency, callId]);

  useEffect(() => {
    if (onCallinsChange) {
      onCallinsChange(!!(text && text.Callins && text.Callins.length > 0));
    }
  }, [text]);

  // Auto-scroll Event Details section
  useEffect(() => {
    const scrollElement = eventDetailsRef.current;
    if (!scrollElement || !text?.EventComments) return;

    // Check if content is scrollable
    const isScrollable = scrollElement.scrollHeight > scrollElement.clientHeight;
    if (!isScrollable) return;

    let scrollInterval;
    let pauseTimeout;

    const startScrolling = () => {
      scrollInterval = setInterval(() => {
        if (!scrollElement) return;

        const { scrollTop, scrollHeight, clientHeight } = scrollElement;
        const isAtBottom = scrollTop + clientHeight >= scrollHeight - 5;
        const isAtTop = scrollTop <= 5;

        if (scrollDirection === 'down') {
          if (isAtBottom) {
            // Pause at bottom before scrolling back up
            clearInterval(scrollInterval);
            pauseTimeout = setTimeout(() => {
              setScrollDirection('up');
            }, 2000);
          } else {
            scrollElement.scrollTop += 1;
          }
        } else {
          if (isAtTop) {
            // Pause at top before scrolling back down
            clearInterval(scrollInterval);
            pauseTimeout = setTimeout(() => {
              setScrollDirection('down');
            }, 2000);
          } else {
            scrollElement.scrollTop -= 1;
          }
        }
      }, 50); // Scroll speed (lower = faster)
    };

    // Start scrolling after initial delay
    const initialDelay = setTimeout(() => {
      startScrolling();
    }, 2000);

    return () => {
      clearTimeout(initialDelay);
      clearTimeout(pauseTimeout);
      clearInterval(scrollInterval);
    };
  }, [text?.EventComments, scrollDirection]);

  return (
    <div>
      {(hasActiveCall || isFullscreenMapVisible) && (
        <div
          style={{
            position: "absolute",
            top: "2%",
            left: "10px",
            zIndex: 1000,
            background: "rgba(0, 0, 0, 0.85)",
            borderRadius: "8px",
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.6), 0 0 0 1px rgba(255, 255, 255, 0.1)",
            maxWidth: "450px",
            backdropFilter: "blur(10px)",
            border: "1px solid rgba(255, 255, 255, 0.1)",
          }}
        >
          <div
            style={{
              background: "linear-gradient(135deg, #dc2626 0%, #991b1b 100%)",
              color: "white",
              padding: "12px 16px",
              borderRadius: "8px 8px 0 0",
              textAlign: "left",
              fontWeight: "700",
              fontSize: "14px",
              textTransform: "uppercase",
              letterSpacing: "1.5px",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.3)",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <span>OPEN ALARM</span>
          </div>
          {cardTextElement}
        </div>
      )}
      {callinsElement}
      {directionsElement}
    </div>
  );
};

export default FloatingMapCard;
